import { IconButton } from '@mui/material';
import { RiMenuFoldFill, RiMenuLine } from "react-icons/ri";
import { useCommonAppContext } from '~/shared/contexts/CommonAppContext';
import { useIsAtOrNarrowerThan } from '~/shared/utils/useBreakpoint';
import eventEmitter from '~/utils/events/event-emitter';
import { getLcn } from '~/utils/labeled-classnames';

const sizes = {
  sm: 'text-xl',
  md: 'text-3xl',
  lg: 'text-4xl',
};


export default function MenuToggle({
  location = 'banner',
  pageUsesSidebar = true,
}: {
  location?: 'banner' | 'side'
  pageUsesSidebar?: boolean
}) {
  const isXs = useIsAtOrNarrowerThan('xs')
  const { sideBarOpen, setSideBarOpen } = useCommonAppContext()

  const toggleSidebar = () => {
    setSideBarOpen(!sideBarOpen)
    eventEmitter.emit(`main_menu.${sideBarOpen ? 'closed' : 'opened'}`)
  }
  const size = location === 'side' ? 'md' : (isXs ? 'md' : 'lg');

  const lcn = getLcn({
    menuToggle: sizes[size],
  });

  if (!pageUsesSidebar) return null;

  const foldIcon = <RiMenuFoldFill className={lcn.menuToggle} />
  const normalIcon = <RiMenuLine className={lcn.menuToggle} />

  const getFoldIcon = () => {
    if (location == 'banner') {
      if (isXs && sideBarOpen) {
        return null;
      } else {
        return foldIcon;
      }
    } else if (location == 'side' && sideBarOpen) {
      return foldIcon
    }
  }

  return (
    <IconButton
      onClick={toggleSidebar}>
      {sideBarOpen ? getFoldIcon() : normalIcon}
    </IconButton>
  );
};